export enum SearchObjectType {
	Menu = 0,
	User = 1,
	Patient = 2,
	Doctor = 3,
	Location = 4,
}

export const SearchObjectTypePathName = {
	[SearchObjectType.User]: 'user',
	[SearchObjectType.Patient]: 'patient',
	[SearchObjectType.Doctor]: 'doctor',
	[SearchObjectType.Location]: 'location',
};

export const SearchObjectTypeColor = {
	[SearchObjectType.User]: '#fffde7',
	[SearchObjectType.Patient]: '#ffe1e1',
	[SearchObjectType.Doctor]: '#e1ffe2',
	[SearchObjectType.Location]: '#dce2ff',
};
